import styled from 'styled-components';

export const CategoryFilterContainer = styled.div`
    display: flex;
    flex-wrap: wrap;
    gap: 15px;
    margin-bottom: 40px;
    justify-content: center; /* Added for consistency */
`;

export const FilterButton = styled.button`
    background-color: ${props => props.$active ? 'var(--primary-color)' : 'transparent'};
    color: ${props => props.$active ? 'var(--background-color)' : 'var(--text-color)'};
    border: 1px solid var(--primary-color);
    padding: 8px 15px;
    font-size: 12px;
    letter-spacing: 1px;
    text-transform: uppercase;
    cursor: pointer;
    transition: all 0.3s ease;

    &:hover {
        /* Keep existing hover */
        background-color: ${props => props.$active ? 'var(--primary-color)' : 'rgba(255, 51, 153, 0.1)'};
    }
`;